import { call, put, takeLatest } from 'redux-saga/effects';
import { actions, types } from './duck';
import { OK, CREATED, NO_CONTENT } from 'http-status-codes';
import {
  getAffiliateBusinesses,
  createAffiliateBusiness,
  getAffiliateBusiness,
  updateAffiliateBusiness,
  deleteAffiliateBusiness
} from './api';
import { safeResolveAsync } from '../../utils';

// Fetch all
// Fetch all
function* getAffiliateBusinessesSaga({ params }) {
  try {
    yield put(actions.getAffiliateBusinessesRequest());

    let page = 1;
    let response = yield call(getAffiliateBusinesses, { ...params, page });
    if (response.status !== OK) {
      yield put(actions.getAffiliateBusinessesFailure(response.statusText));
      return;
    }

    const first = response.data;
    let results = [...(first.results || [])];
    let hasNext = !!first.next;

    while (hasNext) {
      page += 1;
      response = yield call(getAffiliateBusinesses, { ...params, page });
      if (response.status !== OK) {
        yield put(actions.getAffiliateBusinessesFailure(response.statusText));
        return;
      }
      results = results.concat(response.data.results || []);
      hasNext = !!response.data.next;
    }

    // keep the same shape the page already reads (data.results)
    yield put(actions.getAffiliateBusinessesSuccess({ ...first, results, next: null }));
  } catch (error) {
    yield put(actions.getAffiliateBusinessesFailure(error.message));
  }
}

// Create
function* createAffiliateBusinessSaga({ payload, resolve }) {
  try {
    yield put(actions.createAffiliateBusinessRequest());
    const response = yield call(createAffiliateBusiness, payload);
    if (response.status === OK || response.status === CREATED) {
      yield put(actions.createAffiliateBusinessSuccess(response.data)); // updates `created`
      yield safeResolveAsync(resolve, { success: true, data: response.data });

      // optional: refresh full list
      // yield put(actions.getAffiliateBusinesses());
    } else {
      yield put(actions.createAffiliateBusinessFailure(response.statusText));
      yield safeResolveAsync(resolve, { success: false, error: response.statusText });
    }
  } catch (error) {
    yield put(actions.createAffiliateBusinessFailure(error.message));
    yield safeResolveAsync(resolve, { success: false, error: error.message });
  }
}

// Get single
function* getAffiliateBusinessSaga({ id }) {
  try {
    yield put(actions.getAffiliateBusinessRequest());
    const response = yield call(getAffiliateBusiness, id);
    if (response.status === OK) {
      yield put(actions.getAffiliateBusinessSuccess(response.data));
    } else {
      yield put(actions.getAffiliateBusinessFailure(response.statusText));
    }
  } catch (error) {
    yield put(actions.getAffiliateBusinessFailure(error.message));
  }
}

// Update
function* updateAffiliateBusinessSaga({ id, payload, resolve }) {
  try {
    yield put(actions.updateAffiliateBusinessRequest());
    const response = yield call(updateAffiliateBusiness, id, payload);
    if (response.status === OK) {
      yield put(actions.updateAffiliateBusinessSuccess(response.data)); // updates `updated`
      yield safeResolveAsync(resolve, { success: true, data: response.data });

      // optional: refresh full list
      // yield put(actions.getAffiliateBusinesses());
    } else {
      yield put(actions.updateAffiliateBusinessFailure(response.statusText));
      yield safeResolveAsync(resolve, { success: false, error: response.statusText });
    }
  } catch (error) {
    yield put(actions.updateAffiliateBusinessFailure(error.message));
    yield safeResolveAsync(resolve, { success: false, error: error.message });
  }
}

// Delete
function* deleteAffiliateBusinessSaga({ id }) {
  try {
    yield put(actions.deleteAffiliateBusinessRequest());
    const response = yield call(deleteAffiliateBusiness, id);
    if (response.status === NO_CONTENT) {
      yield put(actions.deleteAffiliateBusinessSuccess(id));
    } else {
      yield put(actions.deleteAffiliateBusinessFailure(response.statusText));
    }
  } catch (error) {
    yield put(actions.deleteAffiliateBusinessFailure(error.message));
  }
}

// Watcher
export default function* watcherSaga() {
  yield takeLatest(types.GET_AFFILIATE_BUSINESSES, getAffiliateBusinessesSaga);
  yield takeLatest(types.GET_AFFILIATE_BUSINESS, getAffiliateBusinessSaga);
  yield takeLatest(types.CREATE_AFFILIATE_BUSINESS, createAffiliateBusinessSaga);
  yield takeLatest(types.UPDATE_AFFILIATE_BUSINESS, updateAffiliateBusinessSaga);
  yield takeLatest(types.DELETE_AFFILIATE_BUSINESS, deleteAffiliateBusinessSaga);
}
